// Auto-generated from spreadsheet data
export interface Proverb {
  id: number;
  category_fi: string;
  category_en: string;
  category_sv: string;
  text_fi: string;
  text_en: string;
  text_sv: string;
  description_fi: string;
  description_en: string;
  description_sv: string;
  source: string;
}

export const PROVERBS: Proverb[] = [
  {
    "id": 1,
    "category_fi": "Sananlasku",
    "category_en": "Proverb",
    "category_sv": "Ordspråk",
    "text_fi": "Sauna on köyhän apteekki.",
    "text_en": "The sauna is the poor person’s pharmacy.",
    "text_sv": "Bastun är den fattiges apotek.",
    "description_fi": "Vanha suomalainen sananlasku, joka kuvaa saunan merkitystä kansanparannuksessa, puhdistautumisessa ja vaivojen lievittämisessä aikana, jolloin lääkkeitä ja lääkäreitä oli vähän saatavilla.",
    "description_en": "An old Finnish proverb describing the sauna’s role in folk healing, cleansing and easing ailments at a time when medicines and doctors were not easily available.",
    "description_sv": "Ett gammalt finländskt ordspråk som beskriver bastuns roll inom folkmedicin, rening och lindring av besvär under en tid då läkemedel och läkare inte var lättillgängliga.",
    "source": "https://finlandiafoundation.org/programs/national-sauna-week/sauna-proverbs-and-quotes/"
  },
  {
    "id": 2,
    "category_fi": "Sananlasku",
    "category_en": "Proverb",
    "category_sv": "Ordspråk",
    "text_fi": "Jos ei sauna, viina ja terva auta, niin tauti on kuolemaksi.",
    "text_en": "If sauna, spirits and tar do not help, the illness is fatal.",
    "text_sv": "Om bastu, brännvin och tjära inte hjälper, är sjukdomen dödlig.",
    "description_fi": "Humoristinen ja synkkäsävyinen sananlasku kolmesta perinteisestä suomalaisesta parannuskeinosta: saunasta, alkoholista ja tervasta. Sitä käytetään korostamaan näiden vanhojen hoitokeinojen vahvaa asemaa kansanperinteessä.",
    "description_en": "A humorous, dark proverb referring to three traditional Finnish remedies: sauna, alcohol and tar. It emphasizes the strong place these old treatments held in folk tradition.",
    "description_sv": "Ett humoristiskt och mörkt ordspråk om tre traditionella finländska botemedel: bastu, alkohol och tjära. Det betonar deras starka ställning i äldre folkmedicin.",
    "source": "https://saunologia.fi/kansanuskomuksia-saunasta/"
  },
  {
    "id": 3,
    "category_fi": "Sananlasku",
    "category_en": "Proverb",
    "category_sv": "Ordspråk",
    "text_fi": "Saunassa ollaan kuin kirkossa.",
    "text_en": "In the sauna, one behaves as one would in church.",
    "text_sv": "I bastun uppför man sig som i kyrkan.",
    "description_fi": "Sananlasku muistuttaa, että sauna on rauhallinen ja kunnioitettava paikka. Perinteisesti saunassa vältettiin riitelyä, metelöintiä, kiroilua ja sopimatonta käytöstä.",
    "description_en": "This proverb reminds bathers that the sauna is a peaceful and respected place. Traditionally, arguing, loud behaviour, swearing and misconduct were avoided there.",
    "description_sv": "Ordspråket påminner om att bastun är en lugn och respekterad plats. Traditionellt undvek man gräl, oväsen, svordomar och olämpligt uppförande där.",
    "source": "https://tietava.finlit.fi/juhlakalenteri/juhannus/sauna/"
  },
  {
    "id": 4,
    "category_fi": "Sananlasku",
    "category_en": "Proverb",
    "category_sv": "Ordspråk",
    "text_fi": "Kaksi paikkaa on pyhiä: kirkko ja sauna.",
    "text_en": "Two places are sacred: the church and the sauna.",
    "text_sv": "Två platser är heliga: kyrkan och bastun.",
    "description_fi": "Sananlasku kuvaa saunan erityistä asemaa suomalaisessa kulttuurissa. Saunaa pidettiin puhtauden, hiljaisuuden, syntymän, parantamisen ja hengellisen rauhoittumisen paikkana.",
    "description_en": "The proverb reflects the sauna’s special place in Finnish culture. It was regarded as a place of cleanliness, silence, birth, healing and spiritual calm.",
    "description_sv": "Ordspråket beskriver bastuns särskilda ställning i finländsk kultur. Den sågs som en plats för renhet, tystnad, födelse, läkande och andligt lugn.",
    "source": "https://finlandiafoundation.org/programs/national-sauna-week/sauna-proverbs-and-quotes/"
  },
  {
    "id": 5,
    "category_fi": "Sananlasku",
    "category_en": "Proverb",
    "category_sv": "Ordspråk",
    "text_fi": "Sauna ilman vihtaa on kuin ruoka ilman suolaa.",
    "text_en": "A sauna without a birch whisk is like food without salt.",
    "text_sv": "En bastu utan bastukvast är som mat utan salt.",
    "description_fi": "Sananlasku korostaa vihdan tai vastan merkitystä perinteisessä saunomisessa. Koivunoksilla vihtominen lisää tuoksua, lämmön tunnetta ja rituaalista nautintoa.",
    "description_en": "This proverb highlights the importance of the birch whisk in traditional sauna bathing. Gently whisking the body adds fragrance, a stronger sensation of warmth and ritual enjoyment.",
    "description_sv": "Ordspråket betonar bastukvastens betydelse i traditionellt bastubad. Att varsamt slå kroppen med björkris ger doft, en starkare värmekänsla och en rituell njutning.",
    "source": "https://finlandiafoundation.org/programs/national-sauna-week/sauna-proverbs-and-quotes/"
  },
  {
    "id": 6,
    "category_fi": "Sananlasku",
    "category_en": "Proverb",
    "category_sv": "Ordspråk",
    "text_fi": "Jokaisella saunalla on oma sielunsa.",
    "text_en": "Every sauna has a soul of its own.",
    "text_sv": "Varje bastu har sin egen själ.",
    "description_fi": "Sananlasku kuvaa sitä, että jokainen sauna tuntuu erilaiselta. Rakennus, kiuas, ilmanvaihto, puu, tuoksut, löyly ja käyttäjien tavat luovat saunalle oman tunnelmansa.",
    "description_en": "The proverb expresses the idea that every sauna feels different. Its building, stove, ventilation, wood, scents, steam and bathing customs create a unique atmosphere.",
    "description_sv": "Ordspråket uttrycker tanken att varje bastu känns annorlunda. Byggnaden, kaminen, ventilationen, träet, dofterna, ångan och badvanorna skapar en egen atmosfär.",
    "source": "https://finlandiafoundation.org/programs/national-sauna-week/sauna-proverbs-and-quotes/"
  },
  {
    "id": 7,
    "category_fi": "Sananlasku",
    "category_en": "Proverb",
    "category_sv": "Ordspråk",
    "text_fi": "Talo ilman saunaa ei ole koti.",
    "text_en": "A house without a sauna is not a home.",
    "text_sv": "Ett hus utan bastu är inget hem.",
    "description_fi": "Sananlasku kuvastaa saunan vahvaa yhteyttä suomalaiseen kotiin ja arkeen. Sauna ei ollut vain peseytymispaikka, vaan osa perhe-elämää, juhlia ja viikoittaista rytmiä.",
    "description_en": "The proverb reflects the sauna’s close connection with Finnish home life. It was not merely a place to wash but part of family life, celebrations and the weekly rhythm.",
    "description_sv": "Ordspråket speglar bastuns starka koppling till det finländska hemmet. Den var inte bara en plats för tvagning utan en del av familjelivet, högtiderna och veckorytmen.",
    "source": "https://finlandiafoundation.org/programs/national-sauna-week/sauna-proverbs-and-quotes/"
  },
  {
    "id": 8,
    "category_fi": "Sananlasku",
    "category_en": "Proverb",
    "category_sv": "Ordspråk",
    "text_fi": "Ihminen ilman saunaa on kuin ruumis ilman sielua.",
    "text_en": "A person without a sauna is like a body without a soul.",
    "text_sv": "En människa utan bastu är som en kropp utan själ.",
    "description_fi": "Kuvainnollinen sananlasku, joka korostaa saunan syvää henkistä ja kulttuurista merkitystä. Sauna nähdään sekä kehon että mielen hyvinvoinnin lähteenä.",
    "description_en": "A figurative proverb emphasizing the sauna’s deep spiritual and cultural importance. The sauna is seen as a source of wellbeing for both body and mind.",
    "description_sv": "Ett bildligt ordspråk som betonar bastuns djupa andliga och kulturella betydelse. Bastun ses som en källa till välbefinnande för både kropp och sinne.",
    "source": "https://finlandiafoundation.org/programs/national-sauna-week/sauna-proverbs-and-quotes/"
  },
  {
    "id": 9,
    "category_fi": "Sananlasku",
    "category_en": "Proverb",
    "category_sv": "Ordspråk",
    "text_fi": "Kaikki ihmiset ovat tasa-arvoisia, mutta eivät missään niin kuin saunassa.",
    "text_en": "All people are equal, but nowhere more so than in the sauna.",
    "text_sv": "Alla människor är jämlika, men ingenstans så tydligt som i bastun.",
    "description_fi": "Sananlasku viittaa saunan tasa-arvoistavaan luonteeseen. Saunassa arvonimet, varallisuus ja sosiaalinen asema menettävät merkitystään, ja kaikki ovat samassa lämmössä samanlaisina.",
    "description_en": "The proverb refers to the sauna’s equalizing character. Titles, wealth and social status lose importance there, and everyone shares the same heat on equal terms.",
    "description_sv": "Ordspråket syftar på bastuns jämlikgörande karaktär. Titlar, rikedom och social ställning förlorar sin betydelse, och alla delar samma värme på lika villkor.",
    "source": "https://finlandiafoundation.org/programs/national-sauna-week/sauna-proverbs-and-quotes/"
  },
  {
    "id": 10,
    "category_fi": "Sananlaskun muunnelma",
    "category_en": "Proverb variant",
    "category_sv": "Variant av ordspråk",
    "text_fi": "Jos sauna, viina ja terva ei auta, niin kaivetaan hauta.",
    "text_en": "If sauna, spirits and tar do not help, then dig the grave.",
    "text_sv": "Om bastu, brännvin och tjära inte hjälper, får man gräva graven.",
    "description_fi": "Riimittelevä kansanomainen muunnelma tunnetusta sauna–viina–terva-sananlaskusta. Sitä käytetään leikillisen kohtalokkaasti kuvaamaan vanhojen hoitokeinojen oletettua tehoa.",
    "description_en": "A rhyming folk variant of the well-known sauna–spirits–tar proverb. It is used with grim humour to describe the supposed power of traditional remedies.",
    "description_sv": "En rimmad folklig variant av det kända ordspråket om bastu, brännvin och tjära. Den används med mörk humor för att beskriva de gamla botemedlens påstådda kraft.",
    "source": "https://tietava.finlit.fi/juhlakalenteri/juhannus/sauna/"
  },
  {
    "id": 11,
    "category_fi": "Sanonta",
    "category_en": "Saying",
    "category_sv": "Talesätt",
    "text_fi": "Saunan takana on vielä tilaa.",
    "text_en": "There is still room behind the sauna.",
    "text_sv": "Det finns fortfarande plats bakom bastun.",
    "description_fi": "Vanha, synkän humoristinen sanonta. Saunan takana tehtiin ennen teurastusta ja muita katseilta suojattuja töitä. Nykyisin ilmausta käytetään leikillisenä tai uhkaavana huomautuksena huonosta käytöksestä.",
    "description_en": "An old saying with dark humour. The area behind the sauna was once used for slaughter and other activities kept out of sight. Today it may be used jokingly—or threateningly—about bad behaviour.",
    "description_sv": "Ett gammalt talesätt med mörk humor. Bakom bastun utfördes förr slakt och annat som hölls undan från blickar. I dag används uttrycket skämtsamt eller hotfullt om dåligt uppförande.",
    "source": "https://finlandnaturally.com/sauna/finnish-sauna-sayings/"
  },
  {
    "id": 12,
    "category_fi": "Sanonta",
    "category_en": "Saying",
    "category_sv": "Talesätt",
    "text_fi": "Sauna puhdistaa ruumiin ja mielen.",
    "text_en": "The sauna cleanses the body and the mind.",
    "text_sv": "Bastun renar kropp och sinne.",
    "description_fi": "Yleinen saunaviisaus, joka tiivistää saunomisen fyysisen ja henkisen merkityksen. Sitä käytetään kuvaamaan puhdistumista, rauhoittumista ja stressistä irrottautumista.",
    "description_en": "A common piece of sauna wisdom summarizing both the physical and mental meaning of bathing. It describes cleansing, calming down and letting go of stress.",
    "description_sv": "En vanlig bastuvisdom som sammanfattar både den fysiska och mentala betydelsen av bastubad. Den beskriver rening, lugn och att släppa stress.",
    "source": "https://tietava.finlit.fi/juhlakalenteri/juhannus/sauna/"
  },
  {
    "id": 13,
    "category_fi": "Sanonta",
    "category_en": "Saying",
    "category_sv": "Talesätt",
    "text_fi": "Mene saunaan, kun kroppas sanoo.",
    "text_en": "Go to the sauna when your body tells you to.",
    "text_sv": "Gå i bastun när kroppen säger till.",
    "description_fi": "Kansanomainen, puhekielinen saunasanonta, joka kehottaa kuuntelemaan omaa kehoa. Se liittyy ajatukseen saunasta levon, palautumisen ja vaivojen helpottamisen paikkana.",
    "description_en": "A colloquial folk saying encouraging people to listen to their bodies. It reflects the idea of sauna as a place for rest, recovery and relief from discomfort.",
    "description_sv": "Ett folkligt och talspråkligt bastuuttryck som uppmanar till att lyssna på kroppen. Det knyter an till bastun som plats för vila, återhämtning och lindring.",
    "source": "https://saunologia.fi/kansanuskomuksia-saunasta/"
  },
  {
    "id": 14,
    "category_fi": "Ilmaus",
    "category_en": "Expression",
    "category_sv": "Uttryck",
    "text_fi": "Terveisiä saunasta.",
    "text_en": "Greetings from the sauna.",
    "text_sv": "Hälsningar från bastun.",
    "description_fi": "Tuttu ilmaus, joka sanotaan saunasta palaavalle tai saunomisen jälkeen. Se tunnistaa toisen juuri saunoneeksi ja toimii hyväntahtoisena, arkisena tervehdyksenä.",
    "description_en": "A familiar phrase said to someone returning from the sauna or just after bathing. It acknowledges that the person has saunaed and acts as a friendly everyday greeting.",
    "description_sv": "Ett välkänt uttryck som sägs till någon som kommer från bastun eller just har badat. Det uppmärksammar bastubadet och fungerar som en vänlig vardagshälsning.",
    "source": "https://finlandnaturally.com/sauna/finnish-sauna-sayings/"
  },
  {
    "id": 15,
    "category_fi": "Ilmaus",
    "category_en": "Expression",
    "category_sv": "Uttryck",
    "text_fi": "Löylyt karkaa!",
    "text_en": "The löyly is escaping!",
    "text_sv": "Bastuvärmen smiter ut!",
    "description_fi": "Huudahdus, joka sanotaan, kun saunan ovi jätetään auki liian pitkäksi aikaa. Se muistuttaa sulkemaan oven, jotta lämpö ja kostea löyly eivät pääse ulos.",
    "description_en": "An exclamation used when the sauna door is left open too long. It reminds people to close the door so the heat and humid steam do not escape.",
    "description_sv": "Ett utrop som används när bastudörren står öppen för länge. Det påminner om att stänga dörren så att värmen och den fuktiga ångan inte försvinner.",
    "source": "https://finlandnaturally.com/sauna/finnish-sauna-sayings/"
  },
  {
    "id": 16,
    "category_fi": "Ilmaus",
    "category_en": "Expression",
    "category_sv": "Uttryck",
    "text_fi": "Hyviä löylyjä!",
    "text_en": "Enjoy the löyly!",
    "text_sv": "Njut av bastubadet!",
    "description_fi": "Hyväntahdon toivotus saunaan menevälle. Se vastaa ajatukseltaan hyvän saunahetken toivottamista ja viittaa erityisesti miellyttävään löylyyn.",
    "description_en": "A friendly wish said to someone going into the sauna. It means wishing them an enjoyable sauna session, especially pleasant steam and heat.",
    "description_sv": "En vänlig önskan till den som går in i bastun. Den betyder att man önskar personen ett behagligt bastubad, särskilt skön ånga och värme.",
    "source": "https://finlandnaturally.com/sauna/finnish-sauna-sayings/"
  },
  {
    "id": 17,
    "category_fi": "Uskomus",
    "category_en": "Belief",
    "category_sv": "Folktro",
    "text_fi": "Laskiaisena ei saa puhua saunanlauteilla, muuten hyttyset syövät kesällä.",
    "text_en": "One must not speak on the sauna benches at Shrovetide, or mosquitoes will bite in summer.",
    "text_sv": "Man får inte tala på bastulaven under fastlagstiden, annars blir man biten av mygg på sommaren.",
    "description_fi": "Vanha kalendaarinen kansanuskomus, jossa saunakäyttäytyminen yhdistettiin tulevan kesän onneen ja haittoihin. Hiljaisuus saunassa nähtiin keinona välttää hyttysten vaiva.",
    "description_en": "An old calendar-related folk belief connecting sauna behaviour with good or bad fortune in the coming summer. Silence in the sauna was thought to help prevent mosquito trouble.",
    "description_sv": "En gammal kalenderbunden folktro som kopplade bastubeteende till lycka eller besvär under den kommande sommaren. Tystnad i bastun ansågs skydda mot mygg.",
    "source": "https://tietava.finlit.fi/juhlakalenteri/paasiainen/laskiainen/"
  },
  {
    "id": 18,
    "category_fi": "Uskomus",
    "category_en": "Belief",
    "category_sv": "Folktro",
    "text_fi": "Joulusaunassa piti olla hiljaa, etteivät tontut suuttuisi.",
    "text_en": "People had to remain quiet in the Christmas sauna so the spirits would not become angry.",
    "text_sv": "Man skulle vara tyst i julbastun så att bastutomtarna inte blev arga.",
    "description_fi": "Joulusaunaan liittynyt uskomus korosti hiljaisuutta, rauhaa ja kunnioitusta. Saunatontun tai saunanhaltijan uskottiin valvovan saunaa ja voivan suuttua huonosta käytöksestä.",
    "description_en": "A belief associated with the Christmas sauna emphasizing silence, peace and respect. The sauna spirit was thought to guard the sauna and could become angry at improper behaviour.",
    "description_sv": "En föreställning kring julbastun som betonade tystnad, lugn och respekt. Bastutomten eller bastuväsendet ansågs vaka över bastun och kunde bli arg vid dåligt uppförande.",
    "source": "https://saunologia.fi/kansanuskomuksia-saunasta/"
  },
  {
    "id": 19,
    "category_fi": "Uskomus",
    "category_en": "Belief",
    "category_sv": "Folktro",
    "text_fi": "Saunaan jätettiin löyly saunanhaltijalle.",
    "text_en": "Löyly was left in the sauna for its guardian spirit.",
    "text_sv": "Man lämnade kvar löyly åt bastuns skyddsande.",
    "description_fi": "Saunomisen jälkeen saunaan saatettiin heittää vielä löylyä saunanhaltijalle. Tapa osoitti kunnioitusta saunan henkeä kohtaan ja auttoi ylläpitämään hyviä välejä näkymättömän suojelijan kanssa.",
    "description_en": "After bathing, people might throw one final ladle of water on the stones for the sauna’s guardian spirit. The custom showed respect and maintained good relations with the unseen protector.",
    "description_sv": "Efter bastubadet kunde man kasta en sista skopa vatten på stenarna åt bastuns skyddsande. Seden visade respekt och skulle bevara ett gott förhållande till den osynliga beskyddaren.",
    "source": "https://saunologia.fi/kansanuskomuksia-saunasta/"
  },
  {
    "id": 20,
    "category_fi": "Uskomus",
    "category_en": "Belief",
    "category_sv": "Folktro",
    "text_fi": "Yö kuului vainajille ja muille tuonpuoleisille olennoille.",
    "text_en": "The night belonged to the dead and to other beings of the spirit world.",
    "text_sv": "Natten tillhörde de döda och andra väsen från den andra världen.",
    "description_fi": "Vanhan uskomuksen mukaan ihmisten tuli lopettaa saunominen ajoissa. Myöhäinen yö jätettiin vainajille, saunanhaltijalle ja muille yliluonnollisille olennoille, eikä niiden aikaa saanut häiritä.",
    "description_en": "According to an old belief, people had to finish bathing in good time. The late night was left to the dead, the sauna spirit and other supernatural beings, whose time should not be disturbed.",
    "description_sv": "Enligt gammal folktro skulle människorna avsluta bastubadet i god tid. Den sena natten lämnades åt de döda, bastuväsendet och andra övernaturliga varelser, vars tid inte fick störas.",
    "source": "https://saunologia.fi/kansanuskomuksia-saunasta/"
  }
];
